import _ from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import GoogleTagManagerGql from '@/extensions/marketing/store/graphql/queries/GoogleTagManager.gql';
import SaveGoogleTagManagerGql from '@/extensions/marketing/store/graphql/mutations/SaveGoogleTagManager.gql';

export default {
    fetch: (cmsId) =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: GoogleTagManagerGql,
                    variables: { cms_id: parseInt(cmsId) },
                    fetchPolicy: 'no-cache',
                })
                .then(({ data }) => resolve(data.EX_MARKETING_GoogleTagManager))
                .catch(err => reject(err));
        }),

    save: (googleTagManager) => {
        googleTagManager = _.removeDeepByKey(googleTagManager, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: SaveGoogleTagManagerGql,
                    variables: { googleTagManager },
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.EX_MARKETING_SaveGoogleTagManager);
                })
                .catch(err => reject(err));
        });
    },
};
